import axiosSecurity from '@/services/axios/axiosSecurity'

export default class FuncionalidadeService {
  static async getFuncionalidadesAgrupadasPorModulos(perfilId) {
    const params = new URLSearchParams()

    if (perfilId) {
      params.append('PerfilId', perfilId)
    }

    return axiosSecurity.get(`funcionalidades/agrupadas-por-modulo?${params}`)
  }

  static async getFuncionalidadesByColaborador() {
    return axiosSecurity
      .get('funcionalidades/por-colaborador')
      .then(res => res.data.data.map(f => f.id))
  }
}
